import GeneratedINodeStore from "./generated/GeneratedINodeStore"

class INodeStore extends GeneratedINodeStore {

}

export const iNodeStore = new INodeStore()
